<template>
  <div class='np-modal__container'>
    <div class='spinner-overlay' v-if="submitting">
      <i class='fa fa-spinner fa-spin fa-2x text-white'></i>
    </div>


    <div class='np-modal__user-info row'>
      
      <div class='np-modal__avatar-wrapper col-xs-2'>
        <div v-if="userAvatarUrl">
          <img class='np-modal__user-avatar' :src="userAvatarUrl">
        </div>
        <div class="np-modal__user-avatar" v-if="!userAvatarUrl">
          <span>{{ initials }}</span>
        </div>
      </div>

      <div class='np-modal__posters-name col-xs-10'>
        {{ `${eventAttendee.attendee_fields.first_name} ${eventAttendee.attendee_fields.last_name}`}}
      </div>
    </div>
    
    <div class='np-modal__form-wrapper row'>
      <div class='np-modal__form-container col-xs-12'>
        <form class='form-group' ref='form'>
          <div class='np-modal__file-preview-container' v-show="fileType">
            <div aria-label="Remove uploaded Image" class='remove-prev-btn position-absolute' @click="clearFilePreview">
              <i class='fa fa-times'></i>
            </div>

            <img :src="photoPreview" class='np-modal__image-prev' v-if='isImageFile'>

            <div class='np-modal__ivideo-prev' v-show="isVideoFile">
              <video height="200" width="300" class="video-preview" controls="controls">
                <source src="" id="video-preview-form" ref='vidPreview'>
              </video>
            </div>
          </div>

          <textarea ref='comment' v-model='comment' class='form-control np-modal__post-textarea' :placeholder="lang.get('event_strings.photo_stream.message_placeholder')" rows='6'>
          </textarea>

          <attendee-tag-search
            v-bind:api-auth-token='apiAuthToken'
            v-bind:event-id="eventId"
            v-bind:base-url="baseUrl"
            v-on:select="addTag"
            v-on:remove="removeTag"
            v-bind:tags="tags"
            type="photoForm"
          >
          </attendee-tag-search>

            <div class="base-modal">
              <input 
                type='file' 
                ref='file' 
                id='photo-upload-input' 
                name='photo' 
                style="display: none"
                :accept="acceptTypes"
              >
              <div class='base-add-post form-control np-modal__add-file-btn btn btn-secondary hs-create-post-text' @click="handleFileClick()">
                <i class="fas fa-photo-video"></i>
                <span v-if="isBaseStyle">{{ lang.get('event_strings.photo_stream.add_photo_video') }}</span>
                <span v-else>{{ lang.get('event_strings.photo_stream.add_to_post') }}</span>
              </div>
            
              <div aria-label="Submit comment" class='btn btn-primary np-modal__post-btn' @click='handleSubmitPostClick'>
                {{ lang.get('event_strings.photo_stream.post_text') }}
              </div>
            </div>
            
            <div class='base-hidden form-control np-modal__add-file-btn' @click="handleFileClick()">
              <span>{{ lang.get('event_strings.photo_stream.add_to_post') }}</span>
              <i class="fas fa-photo-video"></i>
            </div>
            
            <div aria-label="Submit comment" class='base-hidden btn btn-primary np-modal__post-btn' @click='handleSubmitPostClick'>
              {{ lang.get('event_strings.photo_stream.post_text') }}
            </div>
                    
        </form>
      </div>
    </div>
  </div>
</template>

<script>

function getExtension(filename) {
  var parts = filename.split('.');
  return parts[parts.length - 1];
}

function isImage(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'png':
      //etc
      return true;
  }
  return false;
}

function isVideo(filename) {
  var ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'm4v':
    case 'avi':
    case 'mpg':
    case 'mp4':
      // etc
      return true;
  }
  return false;
}

export default {

  inject: ['isBaseStyle'],
  props: ['eventAttendee', 'submittingPhoto', 'apiAuthToken', 'eventId', 'cameraType', 'baseUrl', 'photoToEdit'],

  data: function () {
    return {
      photoPreview: null,
      tags: this.photoToEdit ? this.photoToEdit.tagged_attendee_names : [],
      fileType: null,
      comment: this.photoToEdit ? this.photoToEdit.photo_caption : '',
      isPhotoRemoved: false,
    }
  },

  computed: {
    acceptTypes: function () {
      switch (this.cameraType) {
        case 'photo_and_video':
          return 'image/*, video/*'
        case  'photo':
          return 'image/*'
        case  'video':
          return 'video/*'
        default:
          return 'image/*, video/*'
      }
    },

    isImageFile: function () {
      return this.fileType === 'image'
    },

    isVideoFile: function () {
      return this.fileType === 'video'
    },

    initials: function () {
      const attendee_fields = this.eventAttendee.attendee_fields
      if (attendee_fields.first_name && attendee_fields.last_name) {
        return  `${attendee_fields.first_name[0]} ${attendee_fields.last_name[0]}`
      }
    },

    userAvatarUrl: function () {
      const attendee_fields = this.eventAttendee.attendee_fields
      if (!attendee_fields) return
      if (attendee_fields.user_avatar_url) {
        return `${attendee_fields.user_avatar_url}`
      }
    },

    submitting: function () {
      return this.submittingPhoto === this.$fetchStates.fetching
    }
  },

  methods: {

    addTag (eventAttendee) {
      this.tags.push(eventAttendee)
    },

    removeTag(eventAttendee) {
      let index = this.tags.findIndex(ea => ea.event_attendee_id === eventAttendee.event_attendee_id);
      if (index !== -1) {
        this.tags.splice(index, 1);
      }
    },

    handleSubmitPostClick () {
      if (this.submitting) {
        return;
      }

      const comment = this.$refs.comment.value;
      const fileInput = this.$refs.file.files && this.$refs.file.files[0];
      const userTags = this.tags.map(ea => ea.event_attendee_id).join(',');

      if (!comment && !fileInput) {
        return;
      }

      var photoToEditId = this.photoToEdit ? this.photoToEdit.id : null;

      fileInput || this.isPhotoRemoved
          ? this.$emit('submit-file-post', this.$refs.form, comment, userTags, photoToEditId)
          : this.$emit('submit-text-post', comment, userTags, photoToEditId);

      this.isPhotoRemoved = false
    },

    handleFileClick () {
      this.$refs.file.click()
    },

    clearFilePreview () {
      this.photoPreview = null
      this.isPhotoRemoved = true
      this.$refs.file.value = ''
      this.handleFileChange()
      
    },

    handleFileChange () {

      var refs = this.$refs
      const files = this.$refs.file.files
      if (!files || !files[0]) {
        this.fileType = null
        return
      }

      var file = files[0]

      if (isImage(file.name)) {
        this.fileType = 'image'
        var reader = new FileReader();
        var self = this
        reader.onload = function (e) {
          self.photoPreview = e.target.result
        }
        reader.readAsDataURL(file);
        return
      }

      if (isVideo(file.name)) {
        this.fileType = 'video'
        var blob = URL.createObjectURL(file)
        this.$refs.vidPreview.src = blob
        this.$refs.vidPreview.parentElement.load()
        return
      }
      
      // could not determine filetype
      this.fileType = null

    },
  },

  mounted () {
    this.$refs.file.addEventListener('change', this.handleFileChange)

    if (this.photoToEdit) {
      if (this.photoToEdit.photo_url) {
        this.fileType = 'image';
        this.photoPreview = this.photoToEdit.photo_url;
      }
      
      if (this.photoToEdit.video_url) {
        this.fileType = 'video';
        this.$refs.vidPreview.src = this.photoToEdit.video_url;
        this.$refs.vidPreview.parentElement.load();
      }
    }
  }
  
}
</script>

<style scoped>

  .np-modal__container {
    position: relative;
  }

  .spinner-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(156,156,156,0.75);
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .np-modal__user-info {
    margin-bottom: 2rem;
    margin-left: 0px;
    margin-right: 0px;
  }

  .baseEvent .np-modal__user-info {
    display: none;
  }

  .np-modal__image-prev {
    max-height: 150px;
    max-width: 400px;
  }

  .baseEvent .np-modal__image-prev {
    max-height: 100%;
    max-width: 100%;
  }

  .np-modal__post-textarea {
    width: 100%;
    background-color: white;
    border: none;
  }

  .np-modal__add-file-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    background-color: white;  
  }

  .np-modal__post-btn {
    width: 9em;
    float: right;
    /* background-color: black; */
  }

  .np-modal__file-preview-container {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .base-modal {
    display: none;
  }

  @media (max-width: 768px) { 
    .np-modal__image-prev {
      max-width: 250px;
    }
  }

</style>